const mapping = {
  no: "nb-no",
};

const LanguageMapper = (property) => {
  return (mapping[property] || property).toLowerCase();
};

module.exports = LanguageMapper;
